module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/119-brunei-eb07923d476d0da5c98d43809f5f2f55.svg";